import { useSelector } from "react-redux";

import type { NautilusDesignerState } from "@skilitics/nautilus-core-designer-data";

import type { NautilusDesignerAppConfig } from "./appConfig/index.ts";

export type NautilusDesignerAppState = NautilusDesignerState<NautilusDesignerAppConfig>;

export const useNautilusSelector = useSelector.withTypes<NautilusDesignerAppState>();
